module.exports = __webpack_public_path__ + "static/media/marysia.ac2772da.jpg";